import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Link from '../Link/Link';
import useStyles from './Breadcrumb.styles';
const Breadcrumb = ({ link, currentPage }) => {
    const { classes } = useStyles();
    return (_jsx(_Fragment, { children: link && (_jsx(Link, Object.assign({ className: currentPage ? classes.currentPage : classes.linkText }, link, { url: currentPage ? undefined : link.url }))) }));
};
export default Breadcrumb;
